<script setup lang="ts">
import type { KernelColor } from '@medapp/kernel/types'
import { titleCase } from 'scule'

const { app: { buildId = 'dev' } } = useRuntimeConfig()

const color = computed<KernelColor>(() => {
  if (buildId === 'dev') {
    return 'surface-subdued'
  }
  else if (/^v\d/.test(buildId)) {
    return 'brand-soft'
  }

  return 'brand-coral'
})

const formattedBuildId = computed(() => {
  return titleCase(buildId.replace(/^feature\//, '').replace(/[-_/]/, ' '))
})
</script>

<template>
  <KernelBadge
    v-if="$hasRole('Tech')"
    :color
    size="nano"
  >
    {{ formattedBuildId }}
  </KernelBadge>
</template>
